
import { useState, useEffect, useContext } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as CashStack } from "bootstrap-icons/icons/cash-stack.svg";
import { ReactComponent as Cash } from "bootstrap-icons/icons/cash.svg";
import { ReactComponent as CardList } from "bootstrap-icons/icons/card-list.svg";
import { ReactComponent as CardHeading } from "bootstrap-icons/icons/card-heading.svg";
import { ReactComponent as PeopleFill } from "bootstrap-icons/icons/people-fill.svg";
import { ReactComponent as PersonLinesFill } from "bootstrap-icons/icons/person-lines-fill.svg";
import { ReactComponent as ShieldFillPlus } from "bootstrap-icons/icons/shield-fill-plus.svg";
import { ReactComponent as Wallet2 } from "bootstrap-icons/icons/wallet2.svg";
import { ReactComponent as CashCoin } from "bootstrap-icons/icons/cash-coin.svg";
import { ReactComponent as PersonVcardFill } from "bootstrap-icons/icons/person-vcard-fill.svg";
import { ReactComponent as CardCheckList } from "bootstrap-icons/icons/card-checklist.svg";
import formatDate from "../../../components/utils/DateFormatter";
import Spinner from "../../spinner/Spinner";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ApiServices from "../../../api/ApiServices";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import CustomStyles from "../../../components/utils/CustomStyles";
import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
import { handleError } from "../../../components/utils/AuthenticationCheck";
import AxiosApiCall from "../../../api/AxiosApiCall";
import { AuthContext } from "../../../AuthProvider/AuthProvider";


const BranchList = () => {
  const [branchOpe, setBranchOpe] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(false);
  const { permissions } = useContext(AuthContext);
  // console.log("this is all the perm", permissions);

  const navigate = useNavigate();

  //axios api encryption call
  const axios = AxiosApiCall();


  const fetchAllbranchList = async () => {
    setLoading(true);
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      // console.log("this is the token from branch", token);
      if (!token) {
        throw new Error("No access token found.");
      }
      const response = await axios.get(ApiServices.getAllBranchOperations, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });

      const { status, message, data } = response.data;
      // console.log("this is all branch opeartions list", data);

      if (status === 200) {
        const sortedData = data
          .slice()
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

        setBranchOpe(sortedData);
        toast.success(message, { toastId: "product-fetch-success" });
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchAllbranchList();
  }, []);

  // // Handle Delete Confirmation
  // const handleDeleteConfirmation = (branchId) => {
  //   setConfirmationLoading(true);
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "You won't be able to revert this!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#d33",
  //     cancelButtonColor: "#3085d6",
  //     confirmButtonText: "Yes, delete it!",
  //   }).then((result) => {
  //     setConfirmationLoading(false);
  //     if (result.isConfirmed) {
  //       handleDeleteBranch(branchId);
  //     }
  //   });
  // };

  // // Handle Product Deletion
  // const handleDeleteBranch = async (branchId) => {
  //   const formData = {
  //     branch_id: branchId,
  //   };
  //   // console.log("deleting branch with ID:", branchId);

  //   try {
  //     const authData = JSON.parse(localStorage.getItem("auth"));
  //     const token = authData?.token;

  //     if (!token) {
  //       throw new Error("No access token found.");
  //     }

  //     const response = await axios.delete(ApiServices.removeProducts, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "application/json",
  //       },
  //       data: formData,
  //       withCredentials: true,
  //     });

  //     const updateBranch = branchOpe.filter(
  //       (product) => product.branch_id !== branchId
  //     );
  //     setBranchOpe(updateBranch);

  //     const { status, message } = response.data;
  //     if (status === 200) {
  //       toast.success(message, { toastId: "branch-delete-success" });
  //     } else {
  //       handleError({ response: { status, data: { message } } }, navigate);
  //     }
  //   } catch (error) {
  //     handleError(error, navigate);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // Handle Activate Confirmation
  const handleActivateConfirmation = (branchId, isActivated) => {
    const actionText = isActivated ? "Deactivate" : "Activate";
    const confirmButtonColor = isActivated ? "#d33" : "#3085d6";

    setConfirmationLoading(true);

    Swal.fire({
      title: `Are you sure you want to ${actionText} this branch?`,
      text: `This will ${isActivated ? "deactivate" : "activate"} the branch.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: confirmButtonColor,
      cancelButtonColor: "#aaa",
      confirmButtonText: `Yes, ${actionText} it!`,
    }).then((result) => {
      setConfirmationLoading(false);
      if (result.isConfirmed) {
        handleActivateBranch(branchId);
      }
    });
  };

  // Handle branch activation
  const handleActivateBranch = async (branchId) => {
    const formData = {
      branch_id: branchId,
    };
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) {
        throw new Error("No access token found.");
      }
      const response = await axios.patch(ApiServices.activateBranchOpe, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      const { status, message } = response.data;
      if (status === 200) {
        toast.success(message);
        await fetchAllbranchList();
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };


  const handleFilter = (e) => {
    setFilterText(e.target.value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  // Define Expandable Component for Actions
  const ExpandableComponent = ({ data }) => {
    // console.log("data", data.is_activated);
    // console.log("data", data.id);
    let activateButton = null;

    if (permissions.some(permission => permission.name === 'branch.create')) {
      const isActivated = data.is_activated === true || data.is_activated === "true";
      const iconColor = isActivated ? "text-dash3" : "text-dash5";
      const btnLabel = isActivated ? "Deactivate" : "Activate";

      activateButton = (
        <div className="mx-2 my-2 group relative">
          <button
            onClick={() => handleActivateConfirmation(data.id, isActivated)}
            disabled={confirmationLoading}
          >
            <ShieldFillPlus className={`w-5 h-5 ${iconColor}`} />
          </button>
          <div className={`absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block ${iconColor} text-xs px-2 py-1 rounded`}>
            {btnLabel}
          </div>
        </div>
      );
    }

    return (
      <div className="flex justify-start p-4 relative">
        {permissions.some(permission => permission.name === 'branch.view') && (
          <>
            <div className="mx-2 my-2 group relative">
              <Link to="/operations/branch/details" state={{ branchData: data }}>
                <Eye className="w-5 h-5 text-darkGreen3" />
              </Link>
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-darkGreen3 text-xs px-2 py-1 rounded">
                Details
              </div>
            </div>
          </>
        )}

        {permissions.some(permission => permission.name === 'branch.view') && (
          <>
            <div className="mx-2 my-2 group relative">
              <Link to="/operations/branch/activity" state={{ id: data.id }}>
                <PersonLinesFill className="w-5 h-5 text-darkGreen2" />
              </Link>
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-darkGreen2 text-xs px-2 py-1 rounded">
                Activities
              </div>
            </div>
          </>
        )}

        {permissions.some(permission => permission.name === 'branch.edit') && (
          <div className="mx-2 my-2 group relative">
            <Link to="/operations/branch/edit" state={{ data }}>
              <PencilSquare className="w-5 h-5 text-dash4" />
            </Link>
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-dash4 text-xs px-2 py-1 rounded">
              Edit
            </div>
          </div>
        )}

        {permissions.some(permission => permission.name === 'branch.create') && (
          <>
            {/* <div className="mx-2 my-2 group relative">
              <button
                onClick={() => handleDeleteConfirmation(data.id)}
                disabled={confirmationLoading}
              >
                <Trash className="w-5 h-5 text-dash3" />
              </button>
               <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-dash3 text-xs px-2 py-1 rounded">
                Delete
              </div> 
            </div> */}
            {activateButton}
          </>
        )}

        {permissions.some(permission => permission.name === 'branch.view') && (
          <>

            {/* <div className="mx-2 my-2 group relative">
              <Link to="/operations/branch/expenses" state={{ productByRow: data }}>
                <CashStack className="w-5 h-5 text-dash" />
              </Link>
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-dash text-xs px-2 py-1 rounded">
                Expenses
              </div>
            </div> */}
            {/* <div className="mx-2 my-2 group relative">
              <Link to="/operations/branch/vouchers" state={{ data }}>
                <CardHeading className="w-5 h-5 text-black1" />
              </Link>
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-black1 text-xs px-2 py-1 rounded">
                Vouchers
              </div>
            </div> */}
            <div className="mx-2 my-2 group relative">
              <Link to="/operations/branch/customer" state={{ data }}>
                <PeopleFill className="w-5 h-5 text-orange1" />
              </Link>
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-orange1 text-xs px-2 py-1 rounded">
                Customers
              </div>
            </div>
          </>
        )}

        {permissions.some(permission => permission.name === 'branch.view') && (
          <div className="mx-2 my-2 group relative">
            <Link to="/operations/branch/sales" state={{ mydata: data }}>
              <CardList className="w-5 h-5 text-black1" />
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-black1 text-xs whitespace-nowrap">
                Sales
              </div>
            </Link>
          </div>
        )}
        {permissions.some(permission => permission.name === 'wallet.view') && (
          <div className="mx-2 my-2 group relative">
            <Link to="/operations/branch/wallets/history" state={{ data }}>
              <CashStack className="w-5 h-5 text-darkGreen3" />
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-darkGreen3 text-xs whitespace-nowrap">
                Wallets History
              </div>
            </Link>
          </div>
        )}
        {permissions.some(permission => permission.name === 'branch.fund_wallet') && (
          <div className="mx-2 my-2 group relative">
            <Link to="/operations/branch/wallet/funding" state={{ id: data.id }}>
              <Wallet2 className="w-5 h-5 text-dash3" />
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash3 text-xs whitespace-nowrap">
                Fund Wallets
              </div>
            </Link>
          </div>
        )}
        {permissions.some(permission => permission.name === 'branch.incentive.view') && data.status === "active" && (
          <div className="mx-2 my-2 group relative">
            <Link to="/operations/branch/incentives/details" state={{ id: data.id }}>
              <CashCoin className="w-5 h-5 text-orange1" />
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-orange1 text-xs whitespace-nowrap">
                Incentive Details
              </div>
            </Link>
          </div>
        )}
        {permissions.some(permission => permission.name === 'branch.view') && (
          <div className="mx-2 my-2 group relative">
            <Link to="/operations/branch/customer/reports" state={{ mydata: data }}>
              <PersonVcardFill className="w-5 h-5 text-dash4" />
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash4 text-xs whitespace-nowrap">
                Top Customer
              </div>
            </Link>
          </div>
        )}
        {permissions.some(permission => permission.name === 'branch.view') && (
          <div className="mx-2 my-2 group relative">
            <Link to="/operations/branch/products" state={{ data }}>
              <CardCheckList className="w-5 h-5 text-orange1" />
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-orange1 text-xs whitespace-nowrap">
                Branch Product
              </div>
            </Link>
          </div>
        )}
        {permissions.some(permission => permission.name === 'branch.remittance.deduct') && (
          <div className="mx-2 my-2 group relative">
            <Link to="/operations/branch/remittance/deducted" state={{ data }}>
              <Cash className="w-5 h-5 text-dash3" />
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash3 text-xs whitespace-nowrap">
                Deduct Remittance
              </div>
            </Link>
          </div>
        )}

      </div>
    );
  };



  const columns = [

    {
      name: "Branch Name",
      selector: (row) => (row.name ? row.name.toUpperCase() : ""),
      sortable: true,
      width: "300px",
    },

    {
      name: "Branch Manager",
      selector: (row) =>
        Array.isArray(row.sales_representatives) && row.sales_representatives.length > 0
          ? row.sales_representatives.join(", ").toUpperCase()
          : "NOT AVAILABLE",
      sortable: true,
      width: "200px",
    },

    // {
    //   name: "Branch Manager",
    //   selector: (row) => {
    //     // Better handling for sales representatives
    //     if (Array.isArray(row.sales_representatives) && row.sales_representatives.length > 0) {
    //       return row.sales_representatives.join(", ").toUpperCase();
    //     }
    //     return "NOT ASSIGNED";
    //   },
    //   sortable: true,
    //   width: "200px",
    //   // Add a custom cell renderer for better display
    //   cell: (row) => {
    //     const reps = Array.isArray(row.sales_representatives) && row.sales_representatives.length > 0
    //       ? row.sales_representatives.join(", ")
    //       : "NOT ASSIGNED";

    //     const className = reps === "NOT ASSIGNED" ? "text-red-500" : "text-gray-900";

    //     return (
    //       <span className={className}>
    //         {reps.toUpperCase()}
    //       </span>
    //     );
    //   },
    // },
    {
      name: "Status",
      selector: (row) =>
        row.status ? row.status.toUpperCase() : "NOT AVAILABLE",
      sortable: true,
      cell: (row) => {
        const status = row.status?.toLowerCase();
        let statusClass = "";

        if (status === "active") {
          statusClass = "text-dash";
        } else if (status === "pending") {
          statusClass = "text-dash3";
        } else {
          statusClass = "text-dash5";
        }

        return (
          <span className={statusClass}>
            {row.status ? row.status.toUpperCase() : "NOT AVAILABLE"}
          </span>
        );
      },
      width: "120px",
    },

    {
      name: "Phone",
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <span className="block font-bold">
            {row.phone_number
              ? row.phone_number
              : "NOT AVAILABLE"}
          </span>
          <span className="px-3 py-0.5 rounded-md bg-orange1 text-lGrey2 text-xs">
            {row.email
              ? row.email.toLowerCase()
              : "NOT AVAILABLE"}
          </span>
        </div>
      ),
    },
    {
      name: "Activation Status",
      sortable: true,
      cell: (row) => {
        const isActive = row.is_activated === true || row.is_activated === "true";
        const statusText = isActive ? "ACTIVE" : "INACTIVE";
        const statusClass = isActive ? "text-dash" : "text-dash3";

        return (
          <span className={statusClass}>
            {statusText}
          </span>
        );
      },
      width: "200px",
    },

    {
      name: "State",
      selector: (row) => row.state ? row.state.toUpperCase() : "NOT AVAILABLE",
      sortable: true,
      width: "200px",
    },
    {
      name: "City",
      selector: (row) => row.city ? row.city.toUpperCase() : "NOT AVAILABLE",
      sortable: true,
      width: "200px",
    },
    {
      name: "Created By",
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <span className="block font-bold">
            {row.creator.fullname
              ? row.creator.fullname.toUpperCase()
              : "NOT AVAILABLE"}
          </span>
          <span className="px-3 py-0.5 rounded-md bg-dash5 text-lGrey2 text-xs">
            {row.creator.email
              ? row.creator.email
              : "NOT AVAILABLE"}
          </span>
        </div>
      ),
    },
    {
      name: "Date Created",
      selector: (row) => (row.name ? formatDate(row.created_at) : "NOT AVAILABLE"),
      sortable: true,
      width: "200px",
    },
  ];

  const filteredItems = branchOpe.filter((item) =>
    Object.keys(item).some((key) =>
      item[key]?.toString().toLowerCase().includes(filterText.toLowerCase())
    )
  );

  const data = filteredItems.map((branchOpe) => ({
    name: branchOpe.name,
    phone_number: branchOpe.phone_number,
    is_activated: branchOpe.is_activated || "NOT AVAILABLE",
    state: branchOpe.state,
    city: branchOpe.city,
    status: branchOpe.status,
    creator: branchOpe.creator,
    email: branchOpe.email,
    created_at: branchOpe.created_at,
    id: branchOpe.id,
    address: branchOpe.address,
    sales_representatives: branchOpe.sales_representatives || [],
    nin: branchOpe.nin || "NOT AVAILABLE",
    id: branchOpe.id,
    // newly added
    wallet: branchOpe.wallet || null,
    bank_account: branchOpe.bank_account || null,
    wallet_balance: branchOpe.wallet_balance || "0.00",
    incentive_balance: branchOpe.incentive_balance || "0.00",
    float_balance: branchOpe.float_balance || "0.00",
    expense_balance: branchOpe.expense_balance || "0.00",
    notification_status: branchOpe.notification_status || false,
    two_factor_enabled: branchOpe.two_factor_enabled || false,
    created_at: branchOpe.created_at
  }));

  const sortedData = [...data].sort((a, b) => {
    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);
    return dateB - dateA;
  });

  return (
    <div>
      <MainLayouts>
        <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
          <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
            <nav className="bg-gray-200 py-0 px-4 rounded-lg">
              <ol className="list-none p-0 inline-flex mb-2">
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                    Operations
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                    Branch
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-orange1">List</p>
                </li>
              </ol>
            </nav>
          </section>
          <div className="pb-4 bg-white dark:bg-gray-900 flex flex-wrap justify-between">
            <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
              <input
                type="search"
                className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                placeholder="Search"
                value={filterText}
                onChange={handleFilter}
              />
            </div>
            {permissions.some(permission => permission.name === 'branch.create') && (
              <Link
                to="/operations/branch/create"
                className="w-full sm:w-auto text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
              >
                <span className="flex justify-center sm:justify-start mx-2">
                  <PlusSquareFill className="mr-2" />
                  Add New  Branch
                </span>
              </Link>
            )}
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <DataTable
              columns={columns}
              data={sortedData}
              pagination
              highlightOnHover
              striped
              customStyles={CustomStyles}
              noDataComponent={<div>No branch found</div>}
              expandableRows
              expandableRowsComponent={ExpandableComponent}
            />
          )}
        </div>
      </MainLayouts>
    </div>
  );
};

export default BranchList;






